import React from "react";

interface LoaderProps {
  txt?: string;
  className?: string;
}

const Loader: React.FC<LoaderProps> = ({ txt, className }) => {
  return (
    <div
      className={`flex flex-col items-center justify-center py-10 ${className}`}
    >
      <div className="mb-4 h-8 w-8 animate-spin rounded-full border-b-2 border-brand-500"></div>
      {txt && <span className="text-gray-600 dark:text-white">{txt}</span>}
    </div>
  );
};

export default Loader;
